<template>
  <div id="app">
    <!-- Navigation Header -->
    <AppHeader />

    <!-- Main Content Area using Bulma classes -->
    <main class="section">
      <div class="container">
        <!-- Vue Router outlet for page content -->
        <RouterView v-slot="{ Component, route }">
          <Transition name="page" mode="out-in">
            <component :is="Component" :key="route.path" />
          </Transition>
        </RouterView>
      </div>
    </main>

    <!-- Footer -->
    <AppFooter />

    <!-- Global notification container using Bulma notifications -->
    <div class="notification-container">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="notification is-light"
        :class="[`is-${notification.type}`]"
      >
        <button
          class="delete"
          @click="removeNotification(notification.id)"
        ></button>
        {{ notification.message }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { RouterView } from 'vue-router'
import AppFooter from './components/layout/AppFooter.vue'
import AppHeader from './components/layout/AppHeader.vue'
import { useLocale } from './composables/useLocale'
import { useAppStore } from './stores/app'
import { useAuthStore } from './stores/auth'

// Initialize authentication on app mount
useAuthStore()
const appStore = useAppStore()

// Initialize locale handling (watches for user changes and updates locale)
useLocale()

// Get notifications from app store
const { notifications } = storeToRefs(appStore)
const { removeNotification } = appStore
</script>

<style lang="scss">
// Minimal custom styles - let Bulma handle most of the styling
.notification-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  max-width: 400px;

  .notification {
    margin-bottom: 0.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

// Simple page transition animations
.page-enter-active,
.page-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
